import { render, staticRenderFns } from "./UserSafe.vue?vue&type=template&id=4b4fdf52&"
import script from "./UserSafe.vue?vue&type=script&lang=js&"
export * from "./UserSafe.vue?vue&type=script&lang=js&"
import style0 from "./UserSafe.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports